import React, { useState, useMemo, useCallback } from 'react'
import { Tree, Input, Message } from '@arco-design/web-react'
import { getBookLibraryBookPDFUrl } from './utils/api'
import ReactPDF from '../ReactPDF'
import Amplify from '../Amplify'

import styles from './style/search-content-mod.module.less'
interface Props {
  uuid: string
  page: number
  title: string
}

const Pdf = (props: Props) => {
  const { title, uuid, page } = props

  // 上下文放大弹窗
  const [amplifyContentVisible, setAmplifyContentVisible] =
    useState<boolean>(false)

  const ReactPDFContent = useCallback(() => {
    return <ReactPDF url={getBookLibraryBookPDFUrl(uuid, page)} />
  }, [uuid, page])

  return (
    <div className={styles.contextPdf}>
      <div className={styles.arrow}></div>
      {/* 放大 */}
      <Amplify
        right={-16}
        top={-16}
        width={850}
        title={title}
        visible={amplifyContentVisible}
        setVisible={setAmplifyContentVisible}
        content={
          <div className={styles.amplifyContent} style={{ height: '800px' }}>
            <ReactPDFContent />
          </div>
        }
      />
      <div className={styles.contentInner}>
        <ReactPDFContent />
      </div>
    </div>
  )
}

export default Pdf
